import { useForm } from 'react-hook-form';
import { FormInput } from '../../../wrappers/formInput';
import Button from '../../../compopnents/button';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useState } from 'react';
import { Icon } from '@iconify/react';


export type ResetFormFields = {
  firstName: string;
  lastName: string;
  email: string;
  phone: number;
  Newpassword: any;
  Confirmpassword:any;
  defaultValue:any;
  resetCode:number;

}

interface Props {

    ClickHandler: (event: React.MouseEvent<HTMLButtonElement>) => void
}

const validationSchema = Yup.object({
    Newpassword: Yup.string()
    .required("Field is required"),
    // .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#%&])(?=.{8,})/, 'Your password should have min. 8 values and should have an uppercase letter, number and a special character'),
    Confirmpassword: Yup.string()
    .required("Field is required")
    .oneOf([Yup.ref('Newpassword'), null], "Passwords don't match!")
})
  
export const ResetPasswordForm: React.FC <Props> = ({ClickHandler}) => {

  const formOptions = { resolver: yupResolver(validationSchema) }

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ResetFormFields>(formOptions)
    
  const [togglepass1, setTogglepass1] = useState<boolean>(false)
  const [togglepass2, setTogglepass2] = useState<boolean>(false)

  const onSubmit = (data: any) => {
   
    ClickHandler(data)
  }

  return (
    <form >
      <div className="form-group password-filed">
        <FormInput<ResetFormFields>
          id="password1"
          type={togglepass1 ? 'text' : 'password'}
          name="Newpassword"
          size="medium"
          placeholder="New Password"
          label=""
          register={register}
          errors={errors}
        />
        <Icon icon={togglepass1 ? "mdi:eye-off-outline" : "mdi:eye-outline"} className='eye-icon' onClick={() => setTogglepass1((prev) => !prev)} />
      </div>
      <div className="form-group password-filed">
        <FormInput<ResetFormFields>
          id="password2"
          type={togglepass2 ? 'text' : 'password'}
          name="Confirmpassword"
          size="medium"
          placeholder="Confirm Password"
          label=""
          register={register}
          errors={errors}
        />
        <Icon icon={togglepass2 ? "mdi:eye-off-outline" : "mdi:eye-outline"} className='eye-icon' onClick={() => setTogglepass2((prev) => !prev)} />
      </div>
      <Button onClick={handleSubmit(onSubmit)} type="submit" variant="primary" size="large">Reset Password</Button>
    </form>
  );
};

